export const DownloadButton: React.FC = () => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="11.529" height="14" viewBox="0 0 11.529 14">
      <path id="Caminho_1" data-name="Caminho 1" d="M5,17H16.529V15.353H5ZM16.529,7.941H13.235V3H8.294V7.941H5l5.765,5.765Z" transform="translate(-5 -3)" fill="#fff"/>
    </svg>
  )
}

